<script lang="ts">
  import ServiceLinkPanel from '$lib/components/serviceLinkPanel/ServiceLinkPanel.svelte'
  import ButtonFlexPanel from '../(tjenesteSlots)/(panels)/ButtonFlexPanel.svelte'
  import { pageHrefs } from '$lib/constants/breadCrumbConstants'
  import type { LandingPageStudentliv } from '$lib/types/ServicePageTypes'
  import SEO from '$lib/components/seo/SEO.svelte'
  import Studentliv from '$lib/components/icons/largeIcons/Studentliv.svelte'
  import H4 from '$lib/components/typography/H4.svelte'
  import GeneralSectionWrapper from '$lib/wrappers/GeneralSectionWrapper.svelte'
  import H1 from '$lib/components/typography/H1.svelte'
  import Resources from '$lib/components/landingPage/Resources.svelte'
  import { CtaDoubleSection } from '$lib/components/cta'
  import CtaSection from '$lib/components/cta/CtaSection.svelte'

  import LandingPageFaqWrapper from '$lib/components/article/LandingPageFaqWrapper.svelte'

  export let data: LandingPageStudentliv
  const { relevantFaqs, ingress, resources, title, seo, ctaSectionDouble, callToActions, ctaSection1, ctaSection2 } =
    data
</script>

<SEO title={seo?.metaTitle || title} description={seo?.metaDescription || ingress} />

<GeneralSectionWrapper class="bg-primary-50 py-20">
  <Studentliv />
  <H1 class="text-gray-800 pb-4">{title}</H1>
  {#if ingress}
    <H4 class="text-base-black pb-8">{ingress}</H4>
  {/if}
</GeneralSectionWrapper>
<GeneralSectionWrapper class="bg-base-white">
  <ButtonFlexPanel>
    {#each callToActions as cta}
      {#if cta._type === 'internalObject'}
        <ServiceLinkPanel
          href={`${pageHrefs.studentliv()}/${cta.internalLink?.reference.slug}`}
          title={cta.title}
          linkText={cta.internalLink?.title}
          fitHeightToOuterDiv
          >{cta.shortDescription}
        </ServiceLinkPanel>
      {:else if cta._type === 'externalObject'}
        <ServiceLinkPanel
          href={cta.externalLink?.url}
          title={cta.title}
          linkText={cta.externalLink?.title}
          target="_blank"
          fitHeightToOuterDiv
          >{cta.shortDescription}
        </ServiceLinkPanel>
      {/if}
    {/each}
  </ButtonFlexPanel>
</GeneralSectionWrapper>
<LandingPageFaqWrapper {relevantFaqs} />
{#key ctaSectionDouble}
  <CtaDoubleSection {ctaSectionDouble} class="bg-base-white py-4 md:pb-8" />
{/key}
<CtaSection ctaSection={ctaSection1} />
<CtaSection ctaSection={ctaSection2} />
<Resources {resources} pageHref={pageHrefs.studentlivressurser()} />
